import React, { FC } from "react";
import classNames from "classnames";
import { FormatMessage } from "react-globalize";
import makeStyles from "@material-ui/core/styles/makeStyles";
import theme from "styles/theme";

export const DragMessage: FC<{ path: string; className?: string }> = ({ path, className }) => {
    const classes = useMessageStyles();
    return (
        <div className={classNames(classes.root, className)}>
            <FormatMessage path={path} elements={{ br: <br />, span: <span className={classes.span} /> }} />
        </div>
    );
};

const useMessageStyles = makeStyles({
    root: {
        fontSize: 14,
        textAlign: "center",
        lineHeight: "1.8em",
        color: theme.palette.darkGrey,
    },
    span: {
        textDecoration: "underline",
    },
});
